<template>
  <div>
    <h3>
      <span class="header-text">Translational Team - {{ translationalTeam.name }}</span>
      <!-- <b-button class="btn-primary pull-right" :to="{ name: 'translationalTeamEdit', params: {translationalTeamId: translationalTeamId}}">Edit</b-button> -->
      <b-button v-if="canEdit" class="btn-primary pull-right" :to="{
        name: 'translationalTeamEdit',
        params: { translationalTeamId: translationalTeamId }
      }">Edit</b-button>
    </h3>

    <div class="mt-2 mb-2">
      <tags :tags="tags" :can-edit="canEdit" :app="appName" :object="objectName" :object-id="translationalTeamId"
        @success="loadTags()" />
    </div>

    <widget>
      <team-details :translationalTeam="translationalTeam" />
    </widget>

    <widget heading="Description">
      <show-more :text="translationalTeam.description"
        v-if="translationalTeam && translationalTeam.description"></show-more>
    </widget>

    <widget heading="Student Placement Sites">
      <team-sites :sites="sites"></team-sites>
    </widget>

    <widget heading="Opportunities" v-if="translationalTeam.opportunities">
      <team-opportunities :opportunities="translationalTeam.opportunities"></team-opportunities>
    </widget>

    <widget heading="Students">
      <team-students :translationalTeam="translationalTeam"></team-students>
    </widget>

    <widget heading="ASU Team Members">
      <team-employees :translationalTeam="translationalTeam"></team-employees>
    </widget>

    <widget heading="Other Team Members - External">
      <team-external :translationalTeam="translationalTeam"></team-external>
    </widget>

    <widget heading="Community Partners" icon="file-invoice-dollar" v-if="communityPartners">
      <span style="font-weight:bold">Total: {{ communityPartners.length }}
      </span>
      <community-partners-widget :translationalTeamId="translationalTeam.id" :items="communityPartners" manage
        @save="saveCommunityPartners"></community-partners-widget>
    </widget>

    <widget heading="Sponsored Awards" icon="file-invoice-dollar" v-if="awards">
      <awards-widget :translationalTeamId="translationalTeam.id" :awards="awards" manageAwards
        @saveAwards="saveAwards"></awards-widget>
    </widget>

    <widget heading="Proposals" icon="file-invoice-dollar" v-if="proposals">
      <proposals-widget :translationalTeamId="translationalTeam.id" :proposals="proposals" manageProposals
        @saveProposals="saveProposals"></proposals-widget>
    </widget>

    <widget heading="Projects" icon="file-invoice-dollar" v-if="projects">
      <projects-widget :translationalTeamId="translationalTeam.id" :items="projects" manage
        @save="saveProjects"></projects-widget>
    </widget>
  </div>
</template>

<script>
import TeamDetails from "../../components/translationalteams/team-details";
import TeamSites from "../../components/translationalteams/team-sites";
import TeamOpportunities from "../../components/translationalteams/team-opportunities";
import TeamStudents from "../../components/translationalteams/team-students";
import TeamEmployees from "../../components/translationalteams/team-employees";
import TeamExternal from "../../components/translationalteams/team-external";
import Widget from "../../components/widget";
import AwardsWidget from "../../components/awards";
import CommunityPartnersWidget from "../../components/community-partners";
import ProposalsWidget from "../../components/proposals";
import ProjectsWidget from "../../components/projects";
import Tags from "../../components/tags";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import ShowMore from "../../components/show-more";
import roleChecks from "../../misc/role-checks";
import translationalTeamApi from "../../api/translationalTeams";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";
import tagsApi from "../../api/objectTags";

export default {
  mixins: [roleChecks],
  data() {
    return {
      awards: [],
      projects: [],
      proposals: [],
      communityPartners: null,
      tags: [],
      appName: process.env.VUE_APP_NAME,
      objectName: "translationalteams",

      dismissSecs: 10,
      showDismissibleAlert: true
    };
  },

  props: {
    translationalTeamId: {
      required: true
    }
  },

  components: {
    "team-details": TeamDetails,
    "team-sites": TeamSites,
    "team-opportunities": TeamOpportunities,
    TeamStudents,
    widget: Widget,
    "show-more": ShowMore,
    TeamEmployees,
    TeamExternal,
    AwardsWidget,
    ProposalsWidget,
    ProjectsWidget,
    CommunityPartnersWidget,
    Tags
  },

  computed: {
    cpHeading: function () {
      return (
        "Community Partners (total " +
        this.translationalTeam.communityPartners.length +
        ")"
      );
    },

    canEdit: function () {
      return (
        this.isTranslationalTeamAdmin ||
        (this.isTranslationalTeamManager &&
          this.isTeamLead(
            this.translationalTeam.translationalTeamMembers,
            this.$store.state.auth.user.userId
          ))
      );
    },
    sites: function () {
      return _.map(this.translationalTeam.translationalTeamSites, function (
        translationalTeamSite
      ) {
        return translationalTeamSite.site;
      });
    },
    href: function () {
      return (
        "https://placements.chs.asu.edu/translational-teams/" +
        this.translationalTeam.translationalTeamId
      );
    },

    translationalTeam: function () {
      return this.$store.state.translationalTeam.translationalTeam;
    }
  },

  methods: {
    loadTags() {
      var that = this;
      tagsApi
        .getObjectTags(this.appName, this.objectName, this.translationalTeamId)
        .then(response => {
          that.tags = response.data;
        });
    },
    saveAwards: function (awards) {
      var that = this;
      translationalTeamApi
        .postAwards(this.translationalTeamId, awards)
        .then(function (response) {
          toastr.options = ToastrSettings;
          toastr.success("The awards have been saved.", "Success");
          that.load();
        });
    },

    saveCommunityPartners: function (communityPartners) {
      var that = this;
      translationalTeamApi
        .postCommunityPartners(this.translationalTeamId, communityPartners)
        .then(function (response) {
          toastr.options = ToastrSettings;
          toastr.success("The community partners have been saved.", "Success");
          that.load();
        });
    },

    saveProposals: function (proposals) {
      var that = this;
      translationalTeamApi
        .postProposals(this.translationalTeamId, proposals)
        .then(function (response) {
          toastr.options = ToastrSettings;
          toastr.success("The proposals have been saved.", "Success");
          that.load();
        });
    },

    saveProjects: function (projects) {
      var that = this;
      translationalTeamApi
        .postProjects(this.translationalTeamId, projects)
        .then(function (response) {
          toastr.options = ToastrSettings;
          toastr.success("The projects  have been saved.", "Success");
          that.load();
        });
    },

    load() {
      this.$store.dispatch(
        "translationalTeam/getTranslationalTeam",
        this.translationalTeamId
      );

      if (this.canViewAwards) {
        translationalTeamApi
          .getAwards(this.translationalTeamId)
          .then(response => {
            this.awards = response.data;
          });
      }

      if (this.canViewCommunityPartners) {
        translationalTeamApi
          .getCommunityPartners(this.translationalTeamId)
          .then(response => {
            this.communityPartners = response.data;
          });
      }

      if (this.canViewProjects) {
        translationalTeamApi
          .getProjects(this.translationalTeamId)
          .then(response => {
            this.projects = response.data;
          });
      }

      if (this.canViewProposals) {
        translationalTeamApi
          .getProposals(this.translationalTeamId)
          .then(response => {
            this.proposals = response.data;
          });
      }
    }

    // for 'infopop'
    // countDownChanged(dismissCountDown) {
    //   this.dismissCountDown = dismissCountDown
    // },

    // showAlert() {
    //   this.dismissCountDown = this.dismissSecs
    // }
  },

  created() {
    this.load();
    this.loadTags();
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  font-size: 13px;
}

.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}
</style>
